import TextEditorOrchestrator from "./TextEditorOrchestrator";

export default TextEditorOrchestrator;
